// src/components/main/HeroSection.jsx

import React, { useEffect, useState, useRef } from "react";
import { fetchFeaturedCompetitions } from "@/services/apiService";
import { useTenant } from "@/contexts/TenantContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";



const InstagramIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className={className}>
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className={className}>
    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className={className}>
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
  </svg>
);
// ---------------------------------------------------------------------------
// Default copy — used on base Zelospace (no tenant branding configured)
// ---------------------------------------------------------------------------
const DEFAULTS = {
  tagline: "Bring It On Home!",
  headline: "Find your next competition.",
  sub: "Have fun creating, connecting, choosing, collaborating, competing, cheering on!!",
};

// ---------------------------------------------------------------------------
// HeroSection
//
// Layout (desktop):
//   [ LEFT: intro copy ]   [ RIGHT: featured card / swiper ]
//
// On mobile the two columns stack: copy on top, card below.
// ---------------------------------------------------------------------------
const HeroSection = () => {
  const { tenant, branding } = useTenant();

  const [featuredList, setFeaturedList] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const comps = await fetchFeaturedCompetitions();
        if (mounted) setFeaturedList(comps);
      } catch (err) {
        console.error("Failed to fetch featured competitions:", err);
        if (mounted) setFeaturedList([]);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Copy resolution — tenant branding takes priority over defaults
  const headline = branding?.headline   ?? DEFAULTS.headline;
  const sub      = branding?.sub_heading ?? DEFAULTS.sub;
  const eyebrow  = branding?.tagline
    ? branding.tagline
    : tenant?.name && tenant.name !== "Zelospace"
    ? `Competitions on ${tenant.name}`
    : null;

  const hasFeatured  = featuredList.length > 0;

  return (
    <section className="w-full mx-auto max-w-[95rem] bg-stone-brown px-4 py-8 md:py-12">

      {/*
        Two-column grid on md+
        Left: intro copy
        Right: featured card(s)
      */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

        {/* =====================================================================
            LEFT — intro copy
           ===================================================================== */}
        <div className="flex flex-col justify-center">

          {eyebrow && (
            <p className="text-xs uppercase tracking-widest text-imperial-red font-semibold mb-3">
              {eyebrow}
            </p>
          )}

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-mikado-yellow leading-tight mb-4">
            {headline}
          </h1>

          <p className="text-sm md:text-base text-swan leading-relaxed max-w-lg">
            {sub}
          </p>

          {branding?.socials && (
              <div className="flex items-center gap-4 mt-5">
                {branding.socials.whatsapp && (
                  <a href={branding.socials.whatsapp} target="_blank" rel="noopener noreferrer"
                    className="text-swan/30 hover:text-swan/60 transition-colors">
                    <WhatsAppIcon className="w-5 h-5" />
                  </a>
                )}
                {branding.socials.instagram && (
                  <a href={branding.socials.instagram} target="_blank" rel="noopener noreferrer"
                    className="text-swan/30 hover:text-swan/60 transition-colors">
                    <InstagramIcon className="w-5 h-5" />
                  </a>
                )}
                {branding.socials.linkedin && (
                  <a href={branding.socials.linkedin} target="_blank" rel="noopener noreferrer"
                    className="text-swan/30 hover:text-swan/60 transition-colors">
                    <LinkedInIcon className="w-5 h-5" />
                  </a>
                )}
              </div>
            )}

        </div>

        {/* =====================================================================
            RIGHT — featured card(s)
           ===================================================================== */}
        <div>
          {hasFeatured ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              loop
              autoplay={{ delay: 5000 }}
              pagination={{ clickable: true }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              className="w-full rounded-2xl overflow-hidden"
            >
              {featuredList.map((comp) => (
                <SwiperSlide key={comp.id}>
                  <FeaturedCard comp={comp} />
                </SwiperSlide>
              ))}
            </Swiper>

          ) : (
            <div className="rounded-2xl bg-pebble-brown border border-white/5 h-48 flex items-center justify-center">
              <p className="text-swan/30 text-sm">No featured featured events here just yet - check below</p>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};

// ---------------------------------------------------------------------------
// FeaturedCard — card shown in the right column
// ---------------------------------------------------------------------------
const FeaturedCard = ({ comp }) => {
  const [countdown, setCountdown] = useState(getCountdown(comp));
  const status = getStatus(comp);

  useEffect(() => {
    const id = setInterval(() => setCountdown(getCountdown(comp)), 1000);
    return () => clearInterval(id);
  }, [comp]);

  const prefix = status === "upcoming" ? "Starting in" : "Ending in";
  const countdownLabel =
    status === "ended" ? "Ended" :
    countdown ? `${prefix} ${countdown}` :
    "—";

  return (
    <div className="relative w-full rounded-2xl overflow-hidden bg-pebble-brown border border-white/5">

      {/* Image area */}
      <div className="relative w-full aspect-video bg-pebble-brown">
        {comp.img_url && (
          <img
            src={comp.img_url}
            alt={comp.title}
            className="w-full h-full object-cover"
          />
        )}
        <span className="absolute top-3 left-3 bg-imperial-red text-white text-[10px] font-bold tracking-widest uppercase px-2 py-1 rounded">
          Featured
        </span>
      </div>

      {/* Info strip */}
      <div className="px-5 py-4">
        <h2 className="text-lg md:text-xl font-bold text-imperial-red leading-snug mb-1">
          {comp.title}
        </h2>
        <p className="text-xs text-swan/50 mb-4 line-clamp-1">
          {comp.headline ?? comp.category ?? "Open"}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-sm font-bold text-imperial-red font-mono tracking-wide">
            {countdownLabel}
          </span>
          <Link to={`/competition/${comp.id}`} state={{ competition: comp }}>
            <Button size="sm">Explore</Button>
          </Link>
        </div>
      </div>

    </div>
  );
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
function getStatus(comp) {
  const now = Date.now();
  const start = comp.start_date ? new Date(comp.start_date).getTime() : null;
  const end = comp.end_date ? new Date(comp.end_date).getTime() : null;
  if (end && now > end) return "ended";
  if (start && now < start) return "upcoming";
  return "live";
}

function getCountdown(comp) {
  const status = getStatus(comp);
  const target =
    status === "upcoming" ? new Date(comp.start_date).getTime() :
    status === "live"     ? new Date(comp.end_date).getTime() :
    null;
  if (!target) return null;
  const diff = target - Date.now();
  if (diff <= 0) return null;
  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export default HeroSection;